import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gpsTrackerSelectKey } from '@components/modals/CreateEditAssetTrackingModal/services/useGPSTrackerSelectQuery';

import { apiClient } from '@services/apiClient';

import { gpsAssetsKey } from './useGPSAssetsQuery';
import { gpsTrackerKey } from './useGPSTrackersQuery';

const gpsAssetDeleteFn = (gpsAssetId: string | number) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/gps-asset/${gpsAssetId}`);

export const useGPSAssetDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: gpsAssetDeleteFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [gpsAssetsKey({})[0]] });
      queryClient.invalidateQueries({ queryKey: [gpsTrackerKey({})[0]] });
      queryClient.invalidateQueries({ queryKey: [gpsTrackerSelectKey()[0]] });
    },
  });
};
